// Components
import { ConfigContext } from '@velinsi/smp-widgets-ui';
import { PlayerComparisonHeader, TournamentComparisonHeader, ComparisonStatisticsRowList } from '../../components/ComparisonSections';
import TailwindTheme from '../../../../../packages/tailwind/tailwind-theme';

// Hooks
import useRootNodeRef from '../../../../../packages/hooks/useRootNodeRef';
import { usePlayersComparison } from '../../hooks/player';

// Types
import { BaseWidgetProps, IFootballPlayerH2hConfig } from '../../../../../packages/types';
import { IThemeCustomization, Themes } from '../../../../../packages/tailwind/types';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import tailwindStyles from '../../styles.css';

export type PlayerH2hWidgetProps = BaseWidgetProps<IFootballPlayerH2hConfig>;

export const PlayerH2hWidget = ({ themes, config, subscribers, shadow, cuid, sdkOptions }: PlayerH2hWidgetProps) => {
  const { ref } = useRootNodeRef();

  const {
    widgetData: { playerOne, playerTwo, statisticsComparison, isLoading },
    handleClick,
  } = usePlayersComparison({
    ...config,
    subscribers,
    dataWidgetCuid: cuid,
    sdkOptions,
  });

  if (!playerOne || !playerTwo) return null;

  return (
    <ConfigContext.Provider value={{ ...config, sdkOptions }}>
      <TailwindTheme
        isLoading={isLoading}
        shadow={shadow}
        themes={themes ? (themes as IThemeCustomization) : undefined}
        dataTheme={config?.dataTheme ? (config.dataTheme as Themes) : undefined}
        refForShadow={ref}
        tailwindStyles={tailwindStyles}
        bgColor='var(--colors-sportEntityContainerPrimaryBgColor)'
      >
        <PlayerComparisonHeader
          playerOne={playerOne}
          playerTwo={playerTwo}
          showPlayerComparison={config?.dataHeaderDisplay}
          handleClick={handleClick}
        />
        <TournamentComparisonHeader tournamentOne={playerOne.tournament} tournamentTwo={playerTwo.tournament} handleClick={handleClick} />
        <ComparisonStatisticsRowList data={statisticsComparison} />
      </TailwindTheme>
    </ConfigContext.Provider>
  );
};
